(() => {
  const storageKey = 'calista:saved-spells:v1';

  const readSavedSpells = () => {
    try {
      const saved = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return new Set(Array.isArray(saved) ? saved.map(String) : []);
    } catch (_error) {
      return new Set();
    }
  };

  const savedSpells = readSavedSpells();

  const writeSavedSpells = () => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify([...savedSpells]));
    } catch (_error) {
      // The visual state still works when browser storage is unavailable.
    }
  };

  const syncButton = (button) => {
    const productId = String(button.dataset.productId || '');
    if (!productId) return;

    const isSaved = savedSpells.has(productId);
    const productTitle = button.dataset.productTitle || 'this spell';
    const label = isSaved ? `Remove ${productTitle} from saved spells` : `Save ${productTitle}`;

    button.classList.toggle('is-saved', isSaved);
    button.setAttribute('aria-pressed', String(isSaved));
    button.setAttribute('aria-label', label);

    const hiddenLabel = button.querySelector('[data-calista-wishlist-label]');
    if (hiddenLabel) hiddenLabel.textContent = label;
  };

  const syncButtons = (root = document) => {
    if (root.matches?.('[data-calista-wishlist-button]')) syncButton(root);
    root.querySelectorAll?.('[data-calista-wishlist-button]').forEach(syncButton);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-calista-wishlist-button]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const productId = String(button.dataset.productId || '');
    if (!productId) return;

    if (savedSpells.has(productId)) {
      savedSpells.delete(productId);
    } else {
      savedSpells.add(productId);
    }

    writeSavedSpells();
    document.querySelectorAll('[data-calista-wishlist-button]').forEach(syncButton);
  });

  document.addEventListener('DOMContentLoaded', () => syncButtons());

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) syncButtons(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
